import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { endpoints, getPaymentInfo, getAccessToken } from "../../service/api";
import { GLOBAL_CONSTANTS } from "../../utils/Constants";
import { Dimmer, Loader } from "semantic-ui-react";
import { Col, Container, Row, Card } from "reactstrap";
import AggregatorsAccordion from "./AggregatorsAccordion/AggregatorsAccordion";
import "./CheckoutRedirectPayment.scss";
import NextStepComponent from "../NextStepComponent";
import { useAlert } from "../shared/AlertContext/AlertContext";
import getSymbolFromCurrency from "currency-symbol-map";
import { formatNumber } from "../../utils/utils";
import { useAuth } from "../shared/AuthContext/AuthContext";

const CheckoutRedirectPayment = () => {
  const [providerList, setProviderList] = useState([]);
  const [accessTokenState, setAccessTokenState] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [paymentData, setPaymentData] = useState();
  const [nextStepConfig, setNextStepConfig] = useState({
    message: null,
    type: null,
    isShow: false,
  });

  const { tenant, publicKey } = useParams();
  const showNotification = useAlert();
  const { getAuthToken } = useAuth();

  const getPayment = async () => {
    const accessToken = await getAuthToken();
    setAccessTokenState(accessToken);

    const response = await getPaymentInfo(endpoints.getPaymentInfo, accessToken, publicKey, tenant);
    if (response.ok) {
      const responseData = await response.json();
      if (responseData.responseCode !== 1000) {
        setNextStepConfig({
          message: responseData.responseMessage,
          type: GLOBAL_CONSTANTS.ERROR_VALUE,
          isShow: true,
        });
        setIsLoading(false);
      } else if (responseData.aggregators !== null) {
        const listOrder = orderDescByAmount(responseData.aggregators);
        setProviderList(listOrder);
      }

      setPaymentData(responseData);
    } else {
      setNextStepConfig({
        type: GLOBAL_CONSTANTS.ERROR_VALUE,
        isShow: true,
      });

      setIsLoading(false);
    }
  };

  const handleContinueWithPayment = (paymentResponse) => {
    setNextStepConfig({
      url: paymentResponse?.url,
      message: paymentResponse.message,
      type: paymentResponse.type,
      isShow: true,
    });
  };

  const handleShowLoader = (showLoader) => {
    setIsLoading(showLoader);
  };

  const orderDescByAmount = (list) => {
    return list.sort((a, b) => a.amount - b.amount);
  };

  const handleShowNotification = (notification) => {
    showNotification(notification.message, notification.type);
  };

  useEffect(() => {
    if (providerList.length <= 0) {
      setIsLoading(true);
      getPayment();
    }
  }, []);

  return (
    <>
      {isLoading && (
        <Dimmer active style={{ position: "fixed" }}>
          <Loader size="massive">Loading</Loader>
        </Dimmer>
      )}
      {!nextStepConfig.isShow ? (
        <Container fluid>
          <Row className="justify-content-center sticky-total">
            <Col xs="12" md="6" className="text-center">
              <Card body className="p-0 ">
                <Row className="align-items-center p-3">
                  <Col md={6} xs={6} className="text-left">
                    <p className="font-weight-bold">Monto Total ({paymentData?.currency})</p>
                  </Col>
                  <Col md={6} xs={6} className="text-right">
                    <h5 className="font-weight-bold">
                      {getSymbolFromCurrency(paymentData?.currency)}{" "}
                      {formatNumber(paymentData?.amount, 2)}
                    </h5>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col xs="12" md="6">
              <p className="font-weight-bold">Select a provider</p>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col xs="12" md="6">
              <Card body className="p-0">
                <AggregatorsAccordion
                  providerList={providerList}
                  onShowNotificationEventOut={handleShowNotification}
                  accessToken={accessTokenState}
                  onContinueWithPaymentEventOut={handleContinueWithPayment}
                  onShowLoaderEventOut={handleShowLoader}
                />
              </Card>
            </Col>
          </Row>
        </Container>
      ) : (
        <NextStepComponent
          message={nextStepConfig.message}
          typeMessage={nextStepConfig.type}
          url={nextStepConfig.url}
        ></NextStepComponent>
      )}
    </>
  );
};

export default CheckoutRedirectPayment;
